export default __webpack_public_path__ + "/public/concept_aggregator_modules.png";